import { forwardRef } from 'react';
import FullGridMobileLayout from './FullGridMobileLayout';

/**
 * Template — phone-sized "Court Availability", light design.
 * @param {object} props
 * @param {object} props.snapshot - buildAvailabilitySnapshot() output
 * @param {'story'|'portrait'} props.format
 * @param {'ranges'|'hourly'} [props.rowMode] - 'hourly' forces one row per hour; 'ranges' merges hours when hourly rows would be too small
 * @param {object} [props.imageSettings] - Availability images settings (font sizes in px, BOOKED colours); see availabilityImageSettingsUtil
 * @returns {JSX.Element}
 */
const FullGridLightMobileTemplate = forwardRef(function FullGridLightMobileTemplate({ snapshot, format, rowMode, imageSettings }, ref) {
  return <FullGridMobileLayout ref={ref} snapshot={snapshot} format={format} rowMode={rowMode} imageSettings={imageSettings} variant="light" />;
});

export default FullGridLightMobileTemplate;
